<h2 mat-dialog-title> {{formTitle}}</h2>
<p-toast [style]="{marginTop: '80px'}">
</p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content>
  <div [formGroup]="form1">
    <div class="container-fluid">


      <div class="row wrap">
        <div class="col-lg-6 col-md-6">
          <div class="row wrap">
            <div class="col-lg-12">
              @if (formAlert) {
                <div class="w-100" style="padding:10px;">
                  <div class="w-100"
                    style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                    <p><b>{{formAlert}}</b></p>
                  </div>
                </div>
              }
            </div>
            <div class="col-lg-12">
              <div class="w-100">
                <h3>Overview</h3>
              </div>
            </div>
            <div class="col-lg-12">
              <mat-form-field class="w-100">
                <mat-label>Season Name</mat-label>
                <input matInput formControlName="name" readonly="{{formReadOnly}}" pTooltip="Public viewable">
                @for (validation of validationMessages.name; track validation) {
                  <mat-error>
                    @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                      <mat-error class="error-message"
                        >
                        {{validation.message}}
                      </mat-error>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field class="w-100">
                <mat-label>Start Date</mat-label>
                <input matInput [matDatepicker]="startDatePicker" placeholder="Follow-Up Date"
                  formControlName="startDate"
                  pTooltip="Start of season - must NOT overlap with previous season's end date.">
                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker disabled="false"></mat-datepicker>
                @for (validation of validationMessages.startDate; track validation) {
                  <mat-error>
                    @if (form1.get('startDate').hasError(validation.type) && (form1.get('startDate').dirty || form1.get('startDate').touched)) {
                      <mat-error class="error-message"
                        >
                      {{validation.message}}</mat-error>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field class="w-100">
                <mat-label>End Date</mat-label> <input matInput [matDatepicker]="endDatePicker"
                placeholder="Follow-Up Date" formControlName="endDate"
                pTooltip="End of season - must NOT overlap with next season's start date.">
                <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #endDatePicker disabled="false"></mat-datepicker>
                @for (validation of validationMessages.endDate; track validation) {
                  <mat-error>
                    @if (form1.get('endDate').hasError(validation.type) && (form1.get('endDate').dirty || form1.get('endDate').touched)) {
                      <mat-error class="error-message"
                        >
                      {{validation.message}}</mat-error>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field class="w-100">
                <mat-label>Rack Rate</mat-label>
                <input matInput formControlName="listPrice" readonly="{{formReadOnly}}"
                  pTooltip="Initial Rack Rate offered.">
                @for (validation of validationMessages.listPrice; track validation) {
                  <mat-error>
                    @if (form1.get('listPrice').hasError(validation.type) && (form1.get('listPrice').dirty || form1.get('listPrice').touched)) {
                      <mat-error class="error-message"
                        >
                        {{validation.message}}
                      </mat-error>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 flex-column">
          <div style="flex: 0 0 calc(100% - 30px)">
            <h3>Settings</h3>
          </div>


          <div style="flex: 0 0 calc(100% - 30px)">
            <mat-label>Min Nights Expected: <b>{{minStayExpected.value}} nights</b></mat-label>
            <div>
              <mat-slider class="flex-1" min="0" max="30"
								step=".25" pTooltip="Range: 0 to 365 as integer. Documents least number of nights of an acceptable booking. Bookings made for less nights will
							be assessd a penalty (see Mark-Ups below)" tooltipPosition="bottom">
                <input matSliderThumb #minStayExpected formControlName="minStayExpected">
              </mat-slider>
            </div>
          </div>

          <div style="flex: 0 0 calc(100% - 30px)">
            <mat-label>Max Nights Expected: <b>{{maxStayExpected.value}} nights</b></mat-label>
            <div>
              <mat-slider class="flex-1" min="0" max="30"
                step=".25"
                pTooltip="Range: 0 to 365 as integer. Documents number of nights of good solid bookings."
                tooltipPosition="bottom">
                <input matSliderThumb #maxStayExpected formControlName="maxStayExpected">
              </mat-slider>
            </div>
          </div>

          <div style="flex: 0 0 calc(100% - 30px)">
            <mat-label>Avg Nights Expected: <b>{{avgStayBySeason.value}} nights</b></mat-label>
            <div>
              <mat-slider class="flex-1" min="0" max="30"
                step=".25"
                pTooltip="Range: 0 to 365 as integer. Documents number of nights of a reasonable booking."
                tooltipPosition="bottom">
                <input matSliderThumb #avgStayBySeason formControlName="avgStayBySeason">
              </mat-slider>
            </div>
          </div>

          <mat-form-field style="flex: 0 0 calc(50% - 30px)">
            <mat-label>Min Nightly Rate $ (Manager)</mat-label>
            <input matInput formControlName="minimumPriceSetByManager" readonly="{{formReadOnly}}"
              pTooltip="Range: 0 to Infinity as currency.  Determines the lowest nightly rate offered even if discounting algorithms would offer a lower price, set by Manager.  Will be overridden by Min Nightly Rate $ set by Owner if exists.">
            @for (validation of validationMessages.minimumPriceSetByManager; track validation) {
              <mat-error>
                @if (form1.get('minimumPriceSetByManager').hasError(validation.type) && (form1.get('minimumPriceSetByManager').dirty || form1.get('minimumPriceSetByManager').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field style="flex: 0 0 calc(50% - 30px)">
            <mat-label>Min Nightly Rate $ (Owner)</mat-label>
            <input matInput formControlName="minimumPriceSetByOwner" readonly="{{formReadOnly}}"
              pTooltip="Range: 0 to Infinity as currency.  Determines the lowest nightly rate offered even if discounting algorithms would offer a lower price, set by Owner.  Overrides Min Nightly Rate $ set by Manager.">
            @for (validation of validationMessages.minimumPriceSetByOwner; track validation) {
              <mat-error>
                @if (form1.get('minimumPriceSetByOwner').hasError(validation.type) && (form1.get('minimumPriceSetByOwner').dirty || form1.get('minimumPriceSetByOwner').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field style="flex: 0 0 calc(50% - 30px)">
            <mat-label>Season Demand</mat-label>
            <mat-select [(value)]="form1.value.seasonCategory" formControlName="seasonCategory"
              pTooltip="Range: Low to High (1-5). Documents perceived demand for accomodations.">
              @for (stat of seasonCategories; track stat) {
                <mat-option [value]="stat.value"> {{stat.name}}
                </mat-option>
              }
            </mat-select>
            @for (validation of validationMessages.seasonCategory; track validation) {
              <mat-error>
                @if (form1.get('seasonCategory').hasError(validation.type) && (form1.get('seasonCategory').dirty || form1.get('seasonCategory').touched)) {
                  <mat-error class="error-message"
                    >
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
          </mat-form-field>

          <div style="flex: 0 0 calc(100% - 30px)">
            <mat-label>Season Occupancy : <b>{{seasonOccupancy.value*100}}%</b></mat-label>
            <div>
              <mat-slider class="flex-1" min="0" max="1" step=".01"
                pTooltip="Range: 0 to 100 as decimal.  Estimates the occupancy for each season for calculations to the rack rate"
                tooltipPosition="bottom">
                <input matSliderThumb #seasonOccupancy formControlName="seasonOccupancy">
              </mat-slider>
            </div>
          </div>

          <mat-form-field style="flex: 0 0 calc(50% - 30px)">
            <mat-label>Rate Bucket Type</mat-label>
            <mat-select [(value)]="form1.value.rateBucketType" formControlName="rateBucketType"
              pTooltip="Auto: Rack Rate adjusted by system or by bulk updates.  Manual:  Rate static, will not change by system or bulk updates.">
              @for (stat of rateBucketTypes; track stat) {
                <mat-option [value]="stat.value"> {{stat.name}}
                </mat-option>
              }
            </mat-select>
            @for (validation of validationMessages.rateBucketType; track validation) {
              <mat-error>
                @if (form1.get('rateBucketType').hasError(validation.type) && (form1.get('rateBucketType').dirty || form1.get('rateBucketType').touched)) {
                  <mat-error class="error-message"
                    >
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
          </mat-form-field>

        </div>
      </div>

      <div class="row">
        <div class="col-lg-12" style="padding-top:50px;">
          <mat-divider></mat-divider>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div class="row">
            <div class="col-lg-12">
              <h3>Discounts</h3>
            </div>

            <mat-form-field class="col-lg-6 col-md-6">
              <mat-label>Rack Rate Discount $ </mat-label>
              <input matInput formControlName="listPriceAdjustmentAmount" readonly="{{formReadOnly}}"
                pTooltip="Overrides Rack Rate AND any discount .">
              @for (validation of validationMessages.listPriceAdjustmentAmount; track validation) {
                <mat-error>
                  @if (form1.get('listPriceAdjustmentAmount').hasError(validation.type) && (form1.get('listPriceAdjustmentAmount').dirty || form1.get('listPriceAdjustmentAmount').touched)) {
                    <mat-error class="error-message"
                      >
                      {{validation.message}}
                    </mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>


            <mat-form-field class="col-lg-6 col-md-6">
              <mat-label>Algorithm</mat-label>
              <mat-select [(value)]="form1.value.discountAlorithm" formControlName="discountAlorithm"
                pTooltip="Selects the algorithm applied to calculate discounts.">
                @for (stat of discountAlorithms; track stat) {
                  <mat-option [value]="stat.value"> {{stat.name}}
                  </mat-option>
                }
              </mat-select>
              @for (validation of validationMessages.discountAlorithm; track validation) {
                <mat-error>
                  @if (form1.get('discountAlorithm').hasError(validation.type) && (form1.get('discountAlorithm').dirty || form1.get('discountAlorithm').touched)) {
                    <mat-error class="error-message"
                      >
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>



            <div class="col-lg-12">
              <mat-label>Rack Rate Adjustment: <b>{{listPriceAdjustmentPercent.value*100}}%</b></mat-label>
              <div>
                <mat-slider class="flex-1" min="-1" max="1" step=".01"
                  pTooltip="Range: -1 to 1 as decimal.  Decreases or increases the rack rate by applying a discount percentage. Applied to all future rack rates immediatly.   Will not go lower than the the Min Nightly Rate $ setting below."
                  tooltipPosition="bottom">
                  <input matSliderThumb #listPriceAdjustmentPercent formControlName="listPriceAdjustmentPercent">
                </mat-slider>
              </div>
            </div>

            <div class="col-lg-12">
              <mat-label>Days to Start Discounting: <b>{{discountLookForwardDays.value}} days</b></mat-label>
              <div>
                <mat-slider class="flex-1" min="0"
                  max="365" step="1"
                  pTooltip="Range: 0 to 365 as integer.  Determines how many days in advance of each available occupancy period to apply discounting algorithms.  A setting of 0 will apply NO discounts regardless of discount settings."
                  tooltipPosition="bottom">
                  <input matSliderThumb #discountLookForwardDays formControlName="discountLookForwardDays">
                </mat-slider>
              </div>
            </div>

            <div class="col-lg-12">
              <mat-label>Max Discount: <b>{{discountMaxPercent.value*100}}%</b></mat-label>
              <div>
                <mat-slider class="flex-1" min="0" max="1"
                  step=".01"
                  pTooltip="Range: 0 to 100 as decimal.  Determines the maximum discount to apply to the rack rate, but will not go lower than the the Min Nightly Rate $ setting below."
                  tooltipPosition="bottom">
                  <input matSliderThumb #discountMaxPercent formControlName="discountMaxPercent">
                </mat-slider>
              </div>
            </div>

            <div class="col-lg-12">
              <mat-label>Connecting Front <u>Or</u> Back Discount Multiplier:
              <b>{{connectingFrontOrBackMultiplier.value*100}}%</b></mat-label>
              <div>
                <mat-slider class="flex-1" min="-1" max="1" step=".01"
									pTooltip="Range: -1 to +1 as decimal.  Negative value will increase discount for connecting either the front OR the back of an existing reservation,
							positive value will decrease the discount for connecting either the front OR the back of an existing reservation.
							Positive values may be used to discourage connecting reservations for housekeeping, deep cleans, owner requirements but will significantly reduce rent revenue." tooltipPosition="bottom">
                  <input matSliderThumb #connectingFrontOrBackMultiplier formControlName="connectingFrontOrBackMultiplier">
                </mat-slider>
              </div>
            </div>


            <div class="col-lg-12">
              <mat-label>Connecting Front <u>And</u> Back Discount Multiplier:
              <b>{{connectingFrontAndBackMultiplier.value*100}}%</b></mat-label>
              <div>
                <mat-slider class="flex-1" min="-1" max="1" step=".01"
									pTooltip="Range: -1 to +1 as decimal.  Negative value will increase discount for connecting both the front AND the back of an existing reservation,
							positive value will decrease the discount for connecting both the front AND the back of an existing reservation.
							Positive values may be used to discourage connecting reservations for housekeeping, deep cleans, owner requirements but will significantly reduce rent revenue." tooltipPosition="bottom">
                  <input matSliderThumb #connectingFrontAndBackMultiplier formControlName="connectingFrontAndBackMultiplier">
                </mat-slider>
              </div>
            </div>



            <div class="col-lg-12">
              <mat-label>Short Gap Adjuster: <b>{{lengthOfStayDiscountFactorOffset.value*100}}%</b></mat-label>
              <div>
                <mat-slider class="flex-1" min="-1" max="1" step=".01" pTooltip="Range: -1 to +1 as decimal. Negative value will increase discount, positive will decrease discount.
									Kicks in if numberOfNights available is less than minNightsExpected. EXAMPLE: There is a two night gap and our minNightsExpected is 3.
									A negative Short Gap Adjuster will reduce the price of the 2 night gap by xx% to incentivize a booking."
                  tooltipPosition="bottom">
                  <input matSliderThumb #lengthOfStayDiscountFactorOffset formControlName="lengthOfStayDiscountFactorOffset">
                </mat-slider>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6">
          <div class="row">
            <div class="col-lg-12">
              <h3>Mark-Ups</h3>
            </div>

            <div class="col-lg-12">
              <mat-label>Short Gap Occupancy Target: <b>{{shortTermGapMultiplier.value*100}}%</b></mat-label>
              <div>
                <mat-slider class="flex-1" min="0"
                  max="1" step=".01"
									pTooltip="Range: 0-1 as decimal.  Applies a penalty if the number of nights available is less than the minNightsExpected.  EXAMPLE: minNightsExpected is 4, but only 3 nights are available in gap.  A setting of 0% means there will be no penalty to rate if they rent 1 out
							of the 3 nights.  A setting of 100% means there would be a 2 night penalty to rate if they rented 1 out of 3 nights"
                  tooltipPosition="bottom">
                  <input matSliderThumb #shortTermGapMultiplier formControlName="shortTermGapMultiplier">
                </mat-slider>
              </div>
            </div>

            <div class="col-lg-12">
              <mat-label>Short Gap Penalty: <b>{{shortTermGapPenaltyPercent.value*100}}%</b></mat-label>
              <div>
                <mat-slider class="flex-1" min="0" max="1" step=".01" pTooltip="Range: 0-1 as decimal.  Determine how much of the Short Term Gap Occupancy Target penalty to apply.  EXAMPLE: A setting of 0% will apply NONE of the Short Term Gap Occupancy Target penalty, a setting of 100% will apply ALL of the Short Term Gap Occupancy Target penalty.
							If 2.8 nights desired but only 2 nights rented, a setting of xx% will apply only to the .8 night penalty."
                  tooltipPosition="bottom">
                  <input matSliderThumb #shortTermGapPenaltyPercent formControlName="shortTermGapPenaltyPercent">
                </mat-slider>
              </div>
            </div>

            <div class="col-lg-12">
              <mat-label>Short Gap Min Required Nights of Revenue: <b>{{shortTermGapMinNightsReqRev.value}}
              nights</b></mat-label>
              <div>
                <mat-slider class="flex-1" min="0" max="10" step=".25"
                  pTooltip="Range: 0-10 as integer.  Determines how many nights of revenue minimum to charge a guest if the avaialble nights is less than the minExpected nights.  EXAMPLE: Assume a 1 nights gap between two Christmas bookings.  A setting of 3 nights will allow the guest to book just the 1 night, but charge them for 3 even though it is a perfect back to back."
                  tooltipPosition="bottom">
                  <input matSliderThumb #shortTermGapMinNightsReqRev formControlName="shortTermGapMinNightsReqRev">
                </mat-slider>
              </div>
            </div>

            <div class="col-lg-12">
              <mat-label>Long Gap Occupancy Target: <b>{{longTermGapMultiplier.value*100}}%</b></mat-label>
              <div>
                <mat-slider class="flex-1" min="0"
                  max="1" step=".01"
									pTooltip="Range: 0-1 as decimal.  EXAMPLE: A setting of 0% means there will be no penalty to rate if they rent 6 out
							of 12 nights with 3 night gaps on either side.  A setting of 100% means there would be a 6 night penalty to rate if they rented 6 out of 12 nights with 3 night gaps on either side"
                  tooltipPosition="bottom">
                  <input matSliderThumb #longTermGapMultiplier formControlName="longTermGapMultiplier">
                </mat-slider>
              </div>
            </div>

            <div class="col-lg-12">
              <mat-label>Long Gap Penalty: <b>{{longTermGapPenaltyPercent.value*100}}%</b></mat-label>
              <div>
                <mat-slider class="flex-1" min="0" max="1" step=".01" pTooltip="Range: 0-1 as decimal.  Determines how much of the Long Term Gap Occupancy Target penalty to apply.  EXAMPLE: A setting of 0% will apply NONE of the Long Term Gap Occupancy Target penalty, a setting of 100% will apply ALL of the Long Term Gap Occupancy Target penalty.
							If 12 nights desired but only 8 nights rented, a setting of xx% will apply only to the 4 night penalty."
                  tooltipPosition="bottom">
                  <input matSliderThumb #longTermGapPenaltyPercent formControlName="longTermGapPenaltyPercent">
                </mat-slider>
              </div>
            </div>

            <div class="col-lg-12">
              <mat-label>Long Gap Empty Occupancy Target: <b>{{longTermGapEmptyMultiplier.value*100}}%</b>
            </mat-label>
            <div>
              <mat-slider class="flex-1" min="0" max="1" step=".01"
									pTooltip="Range: 0-1 as decimal.  EXAMPLE: A setting of 0% means there will be no penalty to rate if they rent 6 out
							of 12 nights with 3 night gaps on either side.  A setting of 100% means there would be a 6 night penalty to rate if they rented 6 out of 12 nights with 3 night gaps on either side"
                tooltipPosition="bottom">
                <input matSliderThumb #longTermGapEmptyMultiplier formControlName="longTermGapEmptyMultiplier">
              </mat-slider>
            </div>
          </div>

          <div class="col-lg-12">
            <mat-label>Long Gap Empty Penalty: <b>{{longTermGapEmptyPenaltyPercent.value*100}}%</b></mat-label>
            <div>
              <mat-slider class="flex-1" min="0" max="1" step=".01" pTooltip="Range: 0-1 as decimal.  Determines how much of the Long Term Gap Occupancy Target penalty to apply.  EXAMPLE: A setting of 0% will apply NONE of the Long Term Gap Occupancy Target penalty, a setting of 100% will apply ALL of the Long Term Gap Occupancy Target penalty.
							If 12 nights desired but only 8 nights rented, a setting of xx% will apply only to the 4 night penalty."
                tooltipPosition="bottom">
                <input matSliderThumb #longTermGapEmptyPenaltyPercent formControlName="longTermGapEmptyPenaltyPercent">
              </mat-slider>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <mat-divider></mat-divider>
      </div>

      <div class="col-lg-6 col-md-6">
        <div class="row">
          <div class="col-lg-12">
            <h3>Marketing</h3>
          </div>

          <mat-form-field class="col-lg-12">
            <mat-label>Public Desc</mat-label>
            <input matInput formControlName="publicRateNote" readonly="{{formReadOnly}}">
            @for (validation of validationMessages.publicRateNote; track validation) {
              <mat-error>
                @if (form1.get('publicRateNote').hasError(validation.type) && (form1.get('publicRateNote').dirty || form1.get('publicRateNote').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>

          <div class="col-lg-12">
            <mat-label>Headline Specials Look Forward Days: <b>{{discountHeadlineSpecialsLookForwardDays.value}}
            days</b></mat-label>
            <div>
              <mat-slider class="flex-1" min="0" max="180" step="1"
                pTooltip="" tooltipPosition="bottom">
                <input matSliderThumb #discountHeadlineSpecialsLookForwardDays formControlName="discountHeadlineSpecialsLookForwardDays">
              </mat-slider>
            </div>
          </div>

          <div class="col-lg-12">
            <mat-label>Headline Specials Min Nights To Analyze:
              <b>{{discountHeadlineSpecialsMinNightsToAnalyze.value}} days</b></mat-label>
              <div>
                <mat-slider class="flex-1" min="0" max="10" step=".01"
                  pTooltip="" tooltipPosition="bottom">
                  <input matSliderThumb #discountHeadlineSpecialsMinNightsToAnalyze formControlName="discountHeadlineSpecialsMinNightsToAnalyze">
                </mat-slider>
              </div>
            </div>

            <div class="col-lg-12">
              <mat-label>Discount Interval Days: <b>{{discountIntervalDays.value}} days</b></mat-label>
              <div>
                <mat-slider class="flex-1" min="0" max="30"
									step=".01" pTooltip="Range: 0+ as integer. Documents how many nights to
							group together as one price for advertising" tooltipPosition="bottom">
                  <input matSliderThumb #discountIntervalDays formControlName="discountIntervalDays">
                </mat-slider>
              </div>
            </div>

            <div class="col-lg-12">
              <mat-label>Discount Combination Days: <b>{{discountCombinationDays.value}} days</b></mat-label>
              <div>
                <mat-slider class="flex-1" min="0"
                  max="30" step=".01"
                  pTooltip="Range: 0+ as integer. Documents minimum number of consecutive nights the rate engine should process in a row so it does not just break before a new season rate start."
                  tooltipPosition="bottom">
                  <input matSliderThumb #discountCombinationDays formControlName="discountCombinationDays">
                </mat-slider>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6">
        </div>

        <div class="col-lg-12">
          <mat-divider></mat-divider>
        </div>

        <div class="col-lg-6 col-md-6">
          <div class="row">
            <div class="col-lg-12">
              <h2 style="padding-top:50px;">Bulk Update Where Criteria</h2>
            </div>
            <div class="col-lg-12">
              <app-search-template [showSearchButton]=true reset="true" searchLabel="Process Update" [showLocations]=true
                [showDevelopments]=true [showShortTermRentals]=true [showRateBuckets]=true [showBedrooms]=true
                [showSeasons]=true [showStartDate]=true [showEndDate]=true (doSearchCB)="onSearchSubmit($event)">
              </app-search-template>
            </div>
            <br>
              <br><br><br><br>
            </div>
          </div>

          <div class="col-lg-12" style="padding-bottom:50px;">
            <br>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="row">
        <div class="col-lg-12" style="padding-top:20px;">
          <button style="float:left;" mat-raised-button (click)="resetForm()">Reset Form</button>
        </div>
        <div class="col-lg-12" style="padding-top:20px;">
          <br>
          </div>
        </div>
      </mat-dialog-actions>